import cardMediaCommunity from '@/assets/images/k12_community_img_wide.svg';
import k12ZonePoster from '@/assets/images/image-20260618-022547.png';

export type CommunityCardContent = {
  eyebrow: string;
  header: string;
  description: string;
  buttonText: string;
  theme: 'primary' | 'primary-light' | 'secondary-light' | 'white';
  media?: string;      
  videoUuid?: string;  
};
export type CommunityConfig = {
  titleEyebrow: string;
  titleHeader: string;
  titleDescription: string;
  learningCoach: CommunityCardContent;
  student: CommunityCardContent;
};
export const COMMUNITY_CONTENT: CommunityConfig = {
  titleEyebrow: "K12 Community",
  titleHeader: "Connect with your community!",
  titleDescription: "You're not alone! Whether online or out and about, you'll find new friends here.",

  learningCoach: {
    eyebrow: "For Learning Coaches",
    header: "Learning Coach Community",
    description:
      "This is your space to connect with peers and become a valued member of a secure, caring network. Make friends you can chat with to share advice and support. You can even connect with local Learning Coaches through the Learning Coach Community map feature, Friends Near Me! ",
    buttonText: "Find Learning Coaches Near You",
    theme: "secondary-light", //Default Theme for Community
    media: cardMediaCommunity, 
  },
  student: {
    eyebrow: "For Students",
    header: "Hang Out in the K12 Zone",
    description:
      "With K12's secure, open-world virtual campus, online school is more social than ever. From scavenger hunts to art competitions and school assemblies, you'll find your community here. During the school year, explore and interact with the K12 Zone. ", //Desc differ for each Role
    buttonText: "Enter the Visitor Zone", // Role Wise
    theme: "primary-light",
    media: k12ZonePoster,
    videoUuid: "BkFWdmF61TADiRfTdJFTGJ",
  },
};
